import { useEffect, useRef } from 'react'
import * as signalR from '@microsoft/signalr'
import userStore from 'stores/userStore'
import { API_URL } from 'config/env'

const hubBase = API_URL.replace(/\/api\/?$/, '')

export default function useFiscalAlertsHub(onAlert) {
  const handlerRef = useRef(onAlert)
  handlerRef.current = onAlert

  useEffect(() => {
    const token = userStore.currentUser?.token
    if (!token) return undefined

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${hubBase}/hubs/fiscal-alerts`, {
        accessTokenFactory: () => token
      })
      .withAutomaticReconnect()
      .build()

    connection.on('FiscalAlert', (alert) => {
      if (handlerRef.current) handlerRef.current(alert)
    })

    connection.start().catch(() => {})

    return () => {
      connection.stop()
    }
  }, [])
}
